import { useDebouncedValue } from "@mantine/hooks";
import type { FC } from "react";

import { useClientManager } from "@megaron/react-clients";

import { SupportTicketOrderTile } from "./SupportTicketOrderTile";

type Props = {
  orderNumber: string;
};

export const SupportTicketLinkedOrder: FC<Props> = ({ orderNumber }) => {
  const trimmedOrderNumber = orderNumber.trim();
  const [debouncedOrderNumber] = useDebouncedValue(trimmedOrderNumber, 300);
  const docs = useClientManager("docs");
  const ordersQuery = docs.searchOrders().useQuery(
    { searchText: debouncedOrderNumber, limit: 5 },
    { enabled: debouncedOrderNumber.length > 0 },
  );
  const exactMatch = (ordersQuery.data?.items ?? []).find((order) => order.number === debouncedOrderNumber);

  if (!exactMatch) {
    return null;
  }

  return <SupportTicketOrderTile orderNumber={exactMatch.number} sellToName={exactMatch.sellToName} />;
};
